import { LOGIN_STREAK_CLAIM, LOGIN_STREAK_RESET, LOGIN_STREAK_REVIVE, LOGIN_STREAK_STATUS } from './contants';

const initState = {
	loginStreakStatus: [],
	// Master = hạng cao nhất, suy ra từ rank của login-streak. Để ở store cho
	// mọi nơi (Home, DailyReward...) dùng chung thay vì tự tính lại.
	isMaster: false,
	loginStreakClaim: [],
	loginStreakRevive: [],
	loginStreakReset: [],
}

const reducerLoginStreakStatus = (state = initState, actions) => {
	switch (actions.type) {
		case LOGIN_STREAK_STATUS:
			return {
				...state,
				loginStreakStatus: actions.payload.data,
				isMaster: actions.payload.data?.rank?.toUpperCase() === 'MASTER',
			}
		case LOGIN_STREAK_CLAIM:
			return {
				...state,
				loginStreakClaim: actions.payload.data,
			}
		case LOGIN_STREAK_REVIVE:
			return {
				...state,
				loginStreakRevive: actions.payload.data,
			}
		case LOGIN_STREAK_RESET:
			return {
				...state,
				loginStreakReset: actions.payload.data,
			}
		default:
			return state
	}
}
export default reducerLoginStreakStatus
